import { defineChain } from "viem";

export const JUNE = defineChain({
  id: 45003,
  chainId: 45003,
  name: "JUNE-Chain",
  network: "JUNE-Chain",
  nativeCurrency: {
    decimals: 18,
    name: "JUNE-Chain",
    symbol: "JUNE",
  },
  rpcUrls: {
    public: { http: ["https://rpc.juneo-mainnet.network/ext/bc/JUNE/rpc"] },
    default: {
      http: ["https://rpc.juneo-mainnet.network/ext/bc/JUNE/rpc"],
    },
  },
  blockExplorers: {
    default: {
      name: "Juneo Scan",
      url: "https://juneoscan.io/chain/2",
    },
  },
  contracts: {
    nft: {
      address: "0xFEF745280a75ad3F58882375C4C6a5a9B13b6542",
    },
  },
});

export const socotraJUNE = defineChain({
  id: 101003,
  chainId: 101003,
  name: "Socotra JUNE-Chain",
  network: "Socotra JUNE-Chain",
  nativeCurrency: {
    decimals: 18,
    name: "Socotra JUNE-Chain",
    symbol: "JUNE",
  },
  rpcUrls: {
    public: { http: ["https://rpc.socotra-testnet.network/ext/bc/JUNE/rpc"] },
    default: {
      http: ["https://rpc.socotra-testnet.network/ext/bc/JUNE/rpc"],
    },
  },
  blockExplorers: {
    default: {
      name: "Juneo Scan",
      url: "https://socotra.juneoscan.io/chain/2",
    },
  },
  contracts: {
    nft: {
      address: "0xcC8AE3D0B65BC9EfC0be5cDb2BbC672D44246f0C",
    },
  },
  testnet: true,
});

export const socotraUSDT1 = defineChain({
  id: 101005,
  chainId: 101005,
  name: "Socotra USDT1-Chain",
  network: "Socotra USDT1-Chain",
  nativeCurrency: {
    decimals: 18,
    name: "Socotra USDT1-Chain",
    symbol: "USDT1",
  },
  rpcUrls: {
    public: { http: ["https://rpc.socotra-testnet.network/ext/bc/USDT1/rpc"] },
    default: {
      http: ["https://rpc.socotra-testnet.network/ext/bc/USDT1/rpc"],
    },
  },
  blockExplorers: {
    default: {
      name: "Juneo Scan",
      url: "https://socotra.juneoscan.io/chain/3",
    },
  },
  contracts: {
    nft: {
      address: "0x78338b48193481D678e8C4C1134efe075EeD46b5",
    },
  },
  testnet: true,
});
